import Tab from 'bootstrap/js/src/tab'

class Tabs{
    create(entry){
        new Tab(entry)
    }
}

export const TabManager = new Tabs()